import classnames from 'classnames';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { Customer } from '../../interfaces/Customer';
import { TicketRoutePaths } from '../../interfaces/Routes';
import { Stylesheet } from '../../interfaces/Stylesheet';
import { useFormatting } from '../../services/hooks/useFormatting';
import StepsService from '../../services/StepsService';
import Alert from '../Alert/Alert';
import FormElement from '../Form/FormElement';
import style from './AddressData.module.scss';

interface AddressDataProps {
  allowCancelling: boolean;
  customer: Customer;
  hashId: string;
  stylesheet: Stylesheet;
}

const AddressData: FC<AddressDataProps> = ({ stylesheet, customer: { address }, allowCancelling, hashId }) => {
  const containerClasses = classnames('col col-xs-12 col-xl-6', style.sidebar);

  const navigate = useNavigate();
  const { t } = useTranslation();
  const { street, postalCode, city } = address;

  const formattedAddress = `${street}, ${postalCode}, ${city}`;
  const { formattedText: alertText } = useFormatting(stylesheet.customerSection.alertMessageText);

  return (
    <div className={containerClasses}>
      <h2>{t('form:addressDetails')}</h2>
      <FormElement
        disabled
        label={t('form:address')}
        name="disabled"
        type="text"
        value={formattedAddress}
      />
      <p dangerouslySetInnerHTML={{ __html: alertText }} />

      {
        allowCancelling ? (
          <div className={style.desktopOnly}>
            <Alert
              className={style.cancellation}
              level="info"
              text={t('alert:cancelTicket')}
              textButton={{
                text: t('alert:clickToCancel'),
                onClick: () => navigate(StepsService.getStepUri(hashId, TicketRoutePaths.cancel)),
              }}
            />
          </div>
        ) : null
      }
    </div>
  );
};

export default AddressData;
